import dayjs from 'dayjs';

export default {
  name: 'formatSimpleDate',
  fn(value, prependWith, unknownText) {
    return value ? `${prependWith}${dayjs(value).format('MMMM D, YYYY')}` : unknownText ?? 'Unknown';
  },
};
